import React, { useEffect, useMemo, useState } from 'react'
import { Card, CardBody, CardHeader, Col, Container, Row, Spinner, Button } from 'reactstrap'
import TableContainer from '../../Components/Common/TableContainerReactTable.js';
import useObtenerPlantillas from '../../Components/Hooks/useObtenerPlantillas.js';
import useCreatePlantilla from '../../Components/Hooks/useCreatePlantilla.js';
import useUpdatePlantilla from '../../Components/Hooks/useUpdatePlantilla.js';
import useDeletePlantilla from '../../Components/Hooks/useDeletePlantilla.js';
import ModalCrearPlantilla from '../../Components/modals/ModalCrearPlantilla.js';
import ModalModificarPlantilla from '../../Components/modals/ModalModificarPlantilla.js';
import ModalLeerPlantilla from '../../Components/modals/ModalLeerPlantilla.js';

const PlantillasCobranza = () => {

    const [selectedPlantilla, setSelectedPlantilla] = useState(null);
    const [refresh, setRefresh] = useState(0);
    const { plantillas, loading, error } = useObtenerPlantillas(refresh);
    const [modalCrearOpen, setModalCrearOpen] = useState(false);
    const [modalModificarOpen, setModalModificarOpen] = useState(false);
    const [modalLeerOpen, setModalLeerOpen] = useState(false);
    const { createPlantilla, loading: createLoading, error: createError } = useCreatePlantilla();
    const { updatePlantilla, loading: updateLoading, error: updateError } = useUpdatePlantilla();
    const { deletePlantilla, loading: deleteLoading, error: deleteError } = useDeletePlantilla();

    useEffect(() => {
        document.title = "Plantillas de Cobranza | Siga ERP";
    }, []);

    const columns = useMemo(
        () => [
            {
                header: "Nombre",
                accessorKey: "name",
                enableColumnFilter: false,
            },
            {
                header: "Fecha Creación",
                accessorKey: "created_at",
                enableColumnFilter: false,
                cell: ({ getValue }) => new Date(getValue()).toLocaleDateString(),
            },
        ],
        []
    );

    const handleCellClick = (cellInfo) => {
        setSelectedPlantilla(cellInfo.rowData);
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardHeader className="d-flex justify-content-between align-items-center">
                                    <h5 className="card-title mb-0">Plantillas de Notificación de Cobranza</h5>
                                    <div className="d-flex align-items-center">
                                        <Button color="primary" className="me-2" onClick={() => setModalCrearOpen(true)} disabled={createLoading}>
                                            <i className="ri-add-line me-1"></i>Crear
                                        </Button>
                                        <Button color="info" className="me-2" onClick={() => { if (selectedPlantilla) setModalLeerOpen(true); }} disabled={!selectedPlantilla}>
                                            <i className="ri-eye-line me-1"></i>Ver
                                        </Button>
                                        <Button color="warning" className="me-2" onClick={() => { if (selectedPlantilla) setModalModificarOpen(true) }} disabled={!selectedPlantilla || updateLoading}>
                                            <i className="ri-edit-line me-1"></i>Modificar
                                        </Button>
                                        <Button color="danger" className="me-2" onClick={async () => {
                                            if (selectedPlantilla && window.confirm('¿Está seguro que desea eliminar una plantilla? Esta acción no se puede deshacer.')) {
                                                const result = await deletePlantilla(selectedPlantilla.id);
                                                if (result.success) {
                                                    alert('Plantilla eliminada');
                                                    setRefresh(prev => prev + 1);
                                                } else {
                                                    alert('Error: ' + result.error);
                                                }
                                            }
                                        }} disabled={!selectedPlantilla || deleteLoading}>
                                            <i className="ri-delete-bin-line me-1"></i>Eliminar
                                        </Button>
                                    </div>
                                </CardHeader>
                                <CardBody>
                                    {error ? <div className="alert alert-danger">{error}</div> : loading ? <div className="text-center"><Spinner animation="border" variant="primary" /></div> : <TableContainer
                                        columns={(columns || [])}
                                        data={plantillas || []}
                                        customPageSize={15}
                                        isGlobalFilter={true}
                                        SearchPlaceholder='Buscar...'
                                        onCellClick={handleCellClick}
                                    />}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
            <ModalCrearPlantilla
                isOpen={modalCrearOpen}
                toggle={() => setModalCrearOpen(false)}
                onSave={async (formData) => {
                    const result = await createPlantilla(formData);
                    if (result.id) {
                        alert('Plantilla creada exitosamente');
                        setModalCrearOpen(false);
                        setRefresh(prev => prev + 1);
                    } else {
                        alert('Error al crear plantilla: ' + result.error);
                    }
                }}
            />
            <ModalModificarPlantilla
                isOpen={modalModificarOpen}
                toggle={() => setModalModificarOpen(false)}
                selectedPlantilla={selectedPlantilla}
                onSave={async (formData) => {
                    const result = await updatePlantilla(selectedPlantilla.id, formData);
                    if (result.success) {
                        alert('Plantilla actualizada exitosamente');
                        setModalModificarOpen(false);
                        setRefresh(prev => prev + 1);
                    } else {
                        alert('Error al actualizar plantilla: ' + result);
                    }
                }}
            />
            <ModalLeerPlantilla
                isOpen={modalLeerOpen}
                toggle={() => setModalLeerOpen(false)}
                selectedPlantilla={selectedPlantilla}
            />
        </React.Fragment>
    )
}

export default PlantillasCobranza;